import React, { useEffect, useState } from 'react';
import picImage from "../../assets/images/picLogo.png";
import { useAppContext } from "../../context/AppContext";
import { LANGUAGES } from "../../utils/AppConstants";
import useLocalization from "../../hooks/useLocalization";
import bhashiniImage from "../../assets/images/bhashini-logo.png";
import headerBg from "../../assets/images/header_bg.jpg";
import deptLogo from "../../assets/images/dept_logo.svg";
import deptLogoW from "../../assets/images/dept_logo_w.svg";
import { useLogger } from "../../utils/UnifiedLogger";
import { Info, MessageCirclePlus } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearInputValue, setInputDisabled, setIsNewChatClicked, setMicButtonDisabled, setSendButtonDisabled } from "../../store/features/ui/uiSlice";
import { deleteDataForTextLockFlow, deleteDataForVoiceLockFlow, setGrievanceAdditionalComments, setGrievanceFileData, setIsHideUserInputFields, setIsSuggestedQuestionsVisible, setSelectedChatId, setSelectedSocketLanguageData } from "../../store/features/message/textContentSlice";
import { clearChatConfig } from '../../utils/chatConfigStorage';
import { resetAppChatState } from '../../utils/appReset/resetAppChatState';
function UserNavbar() {
    const dispatch = useDispatch();

    const {
        userData,
        setIsNewChat,
        selectedLanguageData,
        theme,
        selectedLanguage,
        sharedApiService,
        logout,
        setSelectedLanguageData
    } = useAppContext();
    const { t } = useLocalization();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const { logInfo } = useLogger('UserNavbar', false);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        logInfo("LOGOUT_CLICKED");
        logout();
        setShowUserMenu(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showUserMenu && !event.target.closest(".relative")) {
                setShowUserMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showUserMenu]);
    const portalUrl = import.meta.env.VITE_PORTAL_REDIRECTION_URL;

    const handleNewChat = () => {
        resetAppChatState({
            dispatch,
            sharedApiService,
            setSelectedLanguageData,
          });
      
          setIsNewChat(true);
          dispatch(setIsNewChatClicked(true));
    }

    return (
        <div className="relative w-full">
            <div className="bg-gradient-to-r from-[#FEE39A] via-[#fff] to-[#70D781] h-1"></div>
            <header
                className={`relative px-0 sm:px-4 py-0 sm:py-2 flex flex-col sm:flex sm:flex-row justify-between items-center border-b bg-[#1334A8] sm:bg-[#fff] dark:bg-[#545454] text-white`}
            >
                <img
                    src={headerBg}
                    alt="header bg"
                    className="absolute hidden sm:block top-0 left-0 object-fill h-full w-full"
                />
                {/* Dept Logo */}
                <div
                    className="relative w-full sm:w-fit z-10 flex items-center gap-2 cursor-pointer p-2 sm:p-0"
                    onClick={() => navigate('/')}
                >
                    <img
                        src={deptLogoW}
                        alt="App Logo"
                        className="sm:hidden object-contain"
                    />
                    <img
                        src={deptLogo}
                        alt="App Logo"
                        className="hidden sm:block object-contain"
                    />
                </div>

                <div className="text-center border-t border-[#fff] px-3 py-2 sm:p-0 sm:border-none relative flex w-full sm:w-fit justify-between items-center sm:block sm:justify-center">
                    <h4 className="text-white sm:text-[#1233A8] font-bold">CPGRAMS</h4>
                    <p className="hidden sm:block text-black w-60 leading-4 text-sm">
                        {t("navbar.description")}
                        {/* Centralized Public Grievance Redress And Monitoring System */}
                    </p>
                    <button
                        className="sm:hidden bg-[#EBF0FF] px-2 py-1 text-black rounded-md font-semibold "
                        onClick={handleNewChat}
                    >
                        <div className="flex items-center">
                            <MessageCirclePlus className="text-[#333]" size={24} />
                            <span className="pl-2 text-sm text-[#333]">{t('newChat')}</span>
                        </div>
                    </button>
                </div>
                <div className="hidden sm:flex items-center space-x-4 max-w-full overflow-visible relative">
                    <div className="hidden sm:flex items-center space-x-4">
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="hidden flex items-center gap-x-2 mr-5 font-semibold rounded-md px-4 py-2 bg-white text-black dark:text-white shadow-md hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 dark:bg-[#3B81F6]"
                        >
                            <span className="text-sm">{selectedLanguageData.label}</span>
                            <svg
                                className={`h-3 w-3 transition-transform duration-300 ${dropdownOpen ? "rotate-0" : "rotate-180"
                                    }`}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill={theme === "light" ? "#000000" : "#FFFFFF"}
                                aria-hidden="true"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M10 3a1 1 0 00-.707.293l-7 7a1 1 0 001.414 1.414L10 5.414l6.293 6.293a1 1 0 001.414-1.414l-7-7A1 1 0 0010 3z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>

                        {dropdownOpen && (
                            <div className="absolute top-full mt-2 right-60 z-50 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md shadow-md py-2 w-48 text-center">
                                <div className="max-h-[200px] overflow-y-auto">
                                    {LANGUAGES.filter((lang) => lang.isActive).map(
                                        (lang, index) => (
                                            <div
                                                key={lang.code}
                                                onClick={() => {
                                                    setDropdownOpen(false);
                                                }}
                                                className="cursor-pointer px-4 py-1 text-black hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md"
                                            >
                                                <span className="whitespace-nowrap overflow-hidden text-ellipsis block">
                                                    {lang.label}
                                                </span>
                                            </div>
                                        )
                                    )}
                                </div>
                                <div className="mt-2 border-t border-gray-300 pt-1">
                                    <div className="flex justify-center items-center bg-white rounded-md w-full px-2 h-[30px]">
                                        <span className="text-black text-xs font-medium">
                                            {t("navbar.poweredBy")}
                                        </span>
                                        <div className="hover:scale-105 transform transition duration-200 ease-in-out">
                                            <img
                                                src={bhashiniImage}
                                                alt="Bhashini Logo"
                                                className="h-4 object-contain"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                        <div className="relative">
                            <div
                                className="flex items-center gap-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg p-2 transition-colors"
                                onClick={() => setShowUserMenu(!showUserMenu)}
                            >
                                <div className="truncate text-black dark:text-white text-right">
                                    <div className="font-semibold">
                                        {userData?.name || "User Name"}
                                    </div>
                                    <div className="text-sm truncate">
                                        {userData?.email || "email@example.com"}
                                    </div>
                                </div >
                                <img
                                    src={userData?.profileImage || picImage}
                                    alt="User"
                                    className="w-10 h-10 rounded-full object-cover"
                                />
                                <svg
                                    className={`h-4 w-4 text-black dark:text-white transition-transform duration-200 ${showUserMenu ? "rotate-180" : ""
                                        }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div >

                            {/* User Dropdown Menu */}
                            {
                                showUserMenu && (
                                    <div className="absolute right-0 top-full mt-2 z-50 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg py-2 w-64">
                                        {/* User Info Header */}
                                        <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-600">
                                            <div className="flex items-center gap-3">
                                                <img
                                                    src={userData?.profileImage || picImage}
                                                    alt="User"
                                                    className="w-12 h-12 rounded-full object-cover"
                                                />
                                                <div>
                                                    <div className="font-semibold text-gray-900 dark:text-white">
                                                        {userData?.name || "User Name"}
                                                    </div>
                                                    <div className="text-sm text-gray-600 dark:text-gray-300 truncate">
                                                        {userData?.email || "email@example.com"}
                                                    </div>
                                                    {userData?.mobile && (
                                                        <div className="text-xs text-gray-500 dark:text-gray-400">
                                                            {userData.mobile}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Menu Items */}
                                        <div className="py-2">
                                            <button
                                                onClick={handleLogout}
                                                className="w-full flex items-center gap-3 px-4 py-2 text-left text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
                                            >
                                                <svg
                                                    className="w-4 h-4"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                                    />
                                                </svg>
                                                <span className="text-sm font-medium">{t("logout")}</span>
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        </div >
                    </div >
                    <div className="hidden md:hidden relative flex flex-col items-center">
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="flex items-center gap-x-2 mb-2 font-semibold rounded-md px-4 py-2 bg-white text-black dark:text-white shadow-md hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 dark:bg-[#3B81F6]"
                        >
                            <span className="text-sm">{selectedLanguage}</span>
                            <svg
                                className={`h-3 w-3 transition-transform duration-300 ${dropdownOpen ? "rotate-0" : "rotate-180"
                                    }`}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill={theme === "light" ? "#000000" : "#FFFFFF"}
                                aria-hidden="true"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M10 3a1 1 0 00-.707.293l-7 7a1 1 0 001.414 1.414L10 5.414l6.293 6.293a1 1 0 001.414-1.414l-7-7A1 1 0 0010 3z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>

                        {dropdownOpen && (
                            <div className="absolute top-12 z-50 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md shadow-md py-2  w-48  text-center">
                                <div className="max-h-[200px] overflow-y-auto">
                                    {LANGUAGES.filter((lang) => lang.isActive).map((lang) => (
                                        <div
                                            key={lang.code}
                                            onClick={() => {
                                                setDropdownOpen(false);
                                            }}
                                            className="cursor-pointer px-4 py-1 text-black hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md"
                                        >
                                            <span className="whitespace-nowrap overflow-hidden text-ellipsis block">
                                                {lang.label}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <img
                            src={userData?.profileImage || picImage}
                            alt="User"
                            onClick={() => setShowMobileMenu(!showMobileMenu)}
                            className="w-10 h-10 rounded-full object-cover cursor-pointer"
                        />

                        {showMobileMenu && (
                            <div className="absolute right-0 top-12 z-50 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md py-2 px-4 w-52 text-black dark:text-white">
                                <div className="font-semibold mb-1 truncate">
                                    {userData?.name || "User Name"}
                                </div>
                                <div className="text-sm text-gray-600 dark:text-gray-300 mb-2 truncate">
                                    {userData?.email || "email@example.com"}
                                </div>
                                <button
                                    onClick={handleLogout}
                                    className="w-full bg-red-500 text-white py-1 px-2 rounded hover:bg-red-600 transition-all"
                                >
                                    {t("logout")}
                                </button>
                            </div>
                        )}
                    </div>
                </div >
            </header >
            <div className="flex bg-[#F9FAFF] border-b border-b-[#ddd] items-center px-3 overflow-hidden">

                <Info
                    className="w-6 h-6 rotate-180 text-white fill-yellow-500 flex-shrink-0"
                    // fill="currentColor"
                    aria-hidden="true"
                />

                <div
                    role="region"
                    aria-label="Scrolling text"
                    className="w-full overflow-hidden whitespace-nowrap box-border py-[6px] px-[5px]"
                >
                    <div className="marquee-track text-sm font-medium">
                        <span className="marquee-item" aria-hidden="true">
                            {t("navbar.disclaimer")} {" "}
                            <a href="{portalUrl}" className="text-blue-600">
                                {portalUrl}
                            </a>
                        </span>
                    </div>
                </div>

                {/* Scoped CSS */}
                <style>{`
        @media (max-width: 1250px) {
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .marquee-track {
            display: inline-flex;
            white-space:no-wrap;
            min-width: 200%; /* double width for two copies */
            animation: marquee 20s linear infinite;
            will-change: transform;
          }
          .marquee-item {
            min-width: 100%;
            padding-right: 30px; /* spacing between copies */
            box-sizing: border-box;
          }
        }
        @media (min-width: 1251px) {
          .marquee-track {
              white-space:wrap;
          }
        }
      `}</style>
            </div>
        </div >
    );
}

export default UserNavbar;
